import React from 'react';
import _DashboardIncomeChart from "../partials/_DashboardIncomeChart";

const DashTasksTab = ({updatePage}) => {
    return (
        <>
            <_DashboardIncomeChart/>
        </>
    );
};

export default DashTasksTab;
